import { Helmet } from "react-helmet";

export default function TwitterSeoConfig() {
  const isProd = import.meta.env.VITE_PROD === "true";

  return isProd ? (
    <Helmet>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@DarvinDev" />
      <meta name="twitter:creator" content="@DarvinDev" />
      <meta
        name="twitter:title"
        content="Darvin AI — No-Code Flutter Mobile App Builder from Text"
      />
      <meta
        name="twitter:description"
        content="Turn plain language into native Flutter Mobile Apps — no code needed. Darvin AI designs, builds & ships production-ready Android and iOS releases in minutes."
      />
      <meta
        name="twitter:image"
        content="https://darvin.dev/assets/og-image.jpg"
      />
      <meta
        name="twitter:image:alt"
        content="Darvin AI — No-Code Flutter Mobile App Builder from Text"
      />
    </Helmet>
  ) : null;
}
